<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle"><a id="p7"></a> Rich's Dine and Dash Potatoes</h1>
<p class="left">This quick and easy recipe is from Rich Machesney, who works with Wyatt Fuller creating special bikes and parts for Harley-Davidson. Rich calls Hickory, North Carolina, home and had this to say about his recipe: "For lack of a better name, I call them Dine and Dash Potatoes. Not to recall those days of getting a free meal once in a while, that's another story. I don't think I'd want to put it in writing."</p>
<p class="timebreak"> <br/></p>
<table>
<tr>
<td align="left" valign="top"><b>6</b><br/><b>to</b><br/><b>8</b></td>
<td align="left" valign="top"><b>medium-size potatoes, diced</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>1</b></td>
<td align="left" valign="top"><b>small onion, diced</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>¼</b></td>
<td align="left" valign="top"><b>cup (½ stick) butter, melted</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>2</b></td>
<td align="left" valign="top"><b>tablespoons vegetable oil</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>1</b></td>
<td align="left" valign="top"><b>tablespoon Mrs. Dash seasoning</b></td>
</tr>
</table>
<ol>
<li>Preheat the oven to 400°F.</li>
<li>Place the potatoes and onion in a baking dish and drizzle with the butter and oil. Sprinkle with the Mrs. Dash and bake for 45 minutes, stirring occasionally. They also come out great cooked on a grill in a foil bag.</li>
</ol>
<p class="timebreak"> <br/></p>
<p class="right"><b><span style="font-size: smaller">MAKES</span> 4 <span style="font-size: smaller">TO</span> 6 <span style="font-size: smaller">SERVINGS</span></b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c005.vue?bf53ee90